import { Stack } from "@adfenix/alexandria";
import { Box } from "react-bulma-components";
import { genericContactUsMessage } from "atoms/auth";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import { RealforceLogo } from "static/svg/realforce-logo";
import { ReactNode } from "react";

const StyledBox = styled(Box)`
  && {
    width: 360px;
    min-height: 292px;
    box-shadow: 0 1px 4px 0 #e9edf1, 0 0 0 1px #e9edf1;
    padding: 2rem;
  }
`;

const Container = styled.div<{ dark: boolean }>`
  min-height: 100vh;
  display: flex;
  flex-grow: 1;
  background-color: ${({ dark }) => (dark ? "#050b1f" : "inherit")};
`;

const IEHack = styled.div`
  min-height: inherit;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 auto;
  flex-shrink: 0;
`;

const SVGWrap = styled.div`
  margin: 0 auto;
  text-align: center;
  position: relative;
`;

interface AuthPageProps {
  children: ReactNode;
}

const AuthPage = ({ children }: AuthPageProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const contactUsMessage = useRecoilValue(genericContactUsMessage);
  const contactUsTranslated = t(contactUsMessage);
  const contactUsRealforce = contactUsTranslated.replace(
    "support@adfenix.com",
    "support@realforce.com"
  );
  return (
    <Container dark>
      <IEHack>
        <SVGWrap className="mb-2">
          <RealforceLogo />
        </SVGWrap>

        <StyledBox className="mb-2">{children}</StyledBox>

        <Stack
          alignItems="center"
          display="flex"
          flexDirection="column"
          spacing="m"
        >
          {!pathname.includes("success") && !pathname.includes("temporary") && (
            <span style={{ color: "white" }}>{contactUsRealforce}</span>
          )}
        </Stack>
      </IEHack>
    </Container>
  );
};

export default AuthPage;
